/**
 * CAPTO PUTTING REPORT Reducers
 */
import {
    CAPTOREPORT_ACTION,
    ALL_CAPTOREPORT,
    ADD_CAPTOREPORT,
    DELETE_CAPTOREPORT,
    FETCH_CAPTOREPORT,
    EDIT_CAPTOREPORT
} from 'Actions/types';


const INIT_STATE = {
    captoreportlist: [],
    particularcaptoreport: [],
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case CAPTOREPORT_ACTION:
            return { ...state, loading: true };

        case ALL_CAPTOREPORT:
            return { ...state, loading: false, captoreportlist: action.payload };

        case ADD_CAPTOREPORT:
            return { ...state, loading: false };

        case DELETE_CAPTOREPORT:
            return { ...state, loading: false };

        case FETCH_CAPTOREPORT:
            return { ...state, loading: false, particularcaptoreport: action.payload };

        case EDIT_CAPTOREPORT:
            return { ...state, loading: false, puttingevaluationlist: action.payload };

        default: return { ...state };

    }
}
